import { configureStore as reduxConfigureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import { store as config } from '@config';

import configureObservers from './observers';
import reducers from './reducers';

function configureMiddleware (getDefaultMiddleware) {
  const middlewareList = [];
  const reduxLogger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error
  });

  if (config.devToolsEnabled) middlewareList.push(reduxLogger);

  return getDefaultMiddleware()
    .concat(middlewareList);
}

export function configureStore () {
  return reduxConfigureStore({
    reducer: reducers,
    middleware: configureMiddleware,
    devTools: config.devToolsEnabled
  });
}

const store = configureStore();

configureObservers(store);

export default store;
export { default as actions } from './actions';
export { default as selectors } from './selectors';
